
makePop = async (event) => {
  event.querySelector("#please-select").disabled = true;
  document.querySelector(".vehicles").style.border = "none";
  document.querySelector(".vehicles").style.backgroundColor = "none";
  document.querySelector(".vehicles").style.padding = "0";
  
  const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111003058814613446805_1746117865070&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_2&prev_val=" + [event.options[event.selectedIndex].value] + "&current_val=" + [event.options[event.selectedIndex].value] + "&lang_code=en&pri_lang_code=&_=1746117865079";
  const data = await this.makeRequest(url)
  
  let $model = document.querySelector("#popup-vehicles #model");
  $model.textContent = "";
  buildListValues(data,$model)
  $model.removeAttribute('disabled');
  $model.dispatchEvent(new Event('change'))
};
modelPop = async (event) => {
  let $year = document.querySelector("#popup-vehicles #year");
        $year.textContent = "";
        const url = "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery1110023537087433045767_1746130184965&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_3&prev_val=" + document.querySelector("#popup-vehicles #make").value + "%2C" + event.options[event.selectedIndex].value + "&current_val=" + event.options[event.selectedIndex].value
        const data = await this.makeRequest(url)
        buildListValues(data,$year);
        $year.removeAttribute('disabled');
        $year.dispatchEvent(new Event('change'))
};
yearPop = async (event) => {

 

}
makeRequest = async (url) => {
  return new Promise((resolve, reject) => {
      $.ajax({
          url: url,
          dataType: 'jsonp',
          success: function (data) {
              resolve(data);
          },
          error: function () {
              reject("Ajax error");
          }
      });
  })
}
const PopupVehicleSelector = (config = null) => {
  const cookie = getCookie("vehicle-selector-popup");

  if (cookie) {
    return false;
  }

  if (!validateUrls(config.showInUrls)) {
    return false;
  }
  populateDropdowns()
  document.querySelector('#popup-vehicles [type="submit"]').disabled = false;
  document
    .querySelectorAll(".vehicle-popup-close,.wrapper-close,.popup-close")
    .forEach((element) => {
      element.addEventListener("click", () => {
        document
          .querySelector(".popup-vehicle-selector-container")
          .classList.remove("show");
        
        document.body.style.overflow = "auto";
      });
    });
  setTimeout(() => {
    document.body.style.overflow = "hidden";
    document
      .querySelector(".popup-vehicle-selector-container")
      .classList.add("show");
    setCookie("vehicle-selector-popup", true, config.cookieDays);
  }, config.waitToDisplay * 1500);
};
async function populateDropdowns() {
  InitMake()
  const dataStrings = localStorage.getItem("YMM");
  
  if (dataStrings) {
    const dataDropdowns = JSON.parse(dataStrings);
    getPresetValues(dataDropdowns);
   
  } else {
   
    document
      .querySelectorAll(".popup-vehicle-selector-form select")
      .forEach((element) => {
        element.disabled = false;
      });
  }
}
function buildListValues(data,$model){
  let newSelect = document.createElement('ul');
  newSelect.innerHTML = data.html;

  for (let option of Array.from(newSelect.querySelectorAll('option'))) {
      $model.appendChild(option);
  }
}
function validateUrls(urls) {
  const places = urls.replaceAll('"', '').split(';');

  if (places.includes('everywhere'))
    return true;

  const currentURL = window.location.pathname;
  let pass = false;
  places.forEach(url => {
    if (url == currentURL || (url !== '/' && url.indexOf('*') !== -1 && url.indexOf(currentURL.split('/')?.[1]) !== -1)) {
      pass = true
      console.log(`url`, url);
    }

  })

  return pass
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

async function sendVehiclePopup(event) {
  event.preventDefault();

  let $form = document.querySelector("#popup-vehicles");
  $form.querySelector("[type=submit]").disabled = true;

  var formdata = new FormData();
 
  let model = {};
  for (let key of event.target.elements) {
    if (key.hasAttribute("name")) {
      if (key.selectedOptions) {
        if (key.selectedOptions[0].innerText == "Please Select") continue;

        formdata.append(
          key.getAttribute("name"),
          key.selectedOptions[0].innerText
        );
        model[
          key.getAttribute("name").replace("contact[", "").replace("]", "")
        ] = {
          id: key.selectedOptions[0].value,
          name: key.selectedOptions[0].innerText,
        };
      } else formdata.append(key.getAttribute("name"), key.value);
    }
  }
  
  var requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };
  const localData = {
    make: model.vehicle_make.id,
    model: model.vehicle_model.id,
    year: model.vehicle_year.id
  }

  fetch("https://hooks.zapier.com/hooks/catch/16755338/2m7rj4v", requestOptions)
    .then((response) => response.json())
    .then(async (result) => {
      setCookie('vehicle-selector-popup', true, 30);
      document.querySelector(".after-sent").style.display = "block";
      localStorage.setItem('YMM',JSON.stringify(localData));
      setTimeout(async () => {
        document.querySelector(".popup-vehicle-selector-form .alert-success").style.display = "none";
        // await retrieveComponent();
        window.location.reload();
        // document
        // .querySelector(".popup-vehicle-selector-container")
        // .classList.remove("show");
      }, 3000)
      $form.querySelector("[type=submit]").style.display = "none";
      document.body.style.overflow = "auto";

    }).catch(() => {
      $form.querySelector("[type=submit]").disabled = false
    });
}
async function retrieveComponent() {
  fetch(window.location.pathname).then(response => response.text()).then(html => {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    if (doc.querySelector('.vehicle-selector')) {
      console.log(`doc.querySelector('.vehicle-selector')`, doc.querySelector('.vehicle-selector'));
      const newComponent = doc.querySelector('.vehicle-selector').innerHTML;
      if (!document.querySelector('.vehicle-selector')) {
        const parent = doc.querySelector('.vehicle-selector').parentElement
        parent.innerHTML = newComponent;
      }
      else {
        document.querySelector('.vehicle-selector').parentElement.innerHTML = newComponent;
      }

    }


  });
}
function InitMake() {
  
  const _MAKES = [{
    id: "mk_acura",
    name: "Acura"
  },
  {
    id: "mk_audi",
    name: "Audi"
  },
  {
    id: "mk_bmw",
    name: "BMW"
  },
  {
    id: "mk_cadillac",
    name: "Cadillac"
  },
  {
    id: "mk_chevrolet",
    name: "Chevrolet"
  },
  {
    id: "mk_dodge",
    name: "Dodge"
  },
  {
    id: "mk_ford",
    name: "Ford"
  },
   {
    id: "mk_lexus",
    name: "Lexus"
  },
  {
    id: "mk_gmc",
    name: "GMC"
  },
  {
    id: "mk_jeep",
    name: "Jeep"
  },
  {
    id: "mk_honda",
    name: "Honda"
  },
  {
    id: "mk_lincoln",
    name: "Lincoln"
  },
  {
    id: "mk_mazda",
    name: "Mazda"
  },
  {
    id: "mk_mercedes-benz",
    name: "Mercedes-Benz"
  },
  {
    id: "mk_nissan",
    name: "Nissan"
  },
  {
    id: "mk_porsche",
    name: "Porsche"
  },
  {
    id: "mk_ram",
    name: "Ram"
  },
  {
    id: "mk_scion",
    name: "Scion"
  },
  {
    id: "mk_subaru",
    name: "Subaru"
  },
  {
    id: "mk_toyota",
    name: "Toyota"
  },
  {
    id: "mk_volkswagen",
    name: "Volkswagen"
  }
  ];
  _MAKES.forEach((item) => {
    let newOption = document.createElement("option");
    newOption.value = item.id;
    newOption.innerText = item.name;
    document.querySelector("#popup-vehicles #make").appendChild(newOption);
    document.querySelector("#popup-vehicles #make").disabled = false
});

}
async function getPresetValues(selectedValues) {
  
  Promise.all([
    await this.makeRequest("https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111003058814613446805_1746117865070&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_2&prev_val=" + selectedValues.make + "&current_val=" + selectedValues.make + "&lang_code=en&pri_lang_code=&_=1746117865079"),
    await this.makeRequest("https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery1110023537087433045767_1746130184965&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_3&prev_val=" + selectedValues.make + "%2C" + selectedValues.model + "&current_val=" + selectedValues.model)
  ]).then( ([model,year]) => {
    let $make = document.querySelector(
      "#popup-vehicles #make"
    );
    $make.querySelector('#please-select').disabled = true;
    $make.value = selectedValues.make;
    let $model = document.querySelector("#popup-vehicles #model");
    let $year = document.querySelector("#popup-vehicles #year");
    buildListValues(model,$model);
    buildListValues(year,$year);
    $model.disabled = false
    $year.disabled = false
  })

}
function makeOptions($dropdown, data, emptyValue = false, id = null) {
  $dropdown.textContent = "";
  if (emptyValue) {
    let $emptyValue = document.createElement("option");
    $emptyValue.id = "please-select";
    $emptyValue.innerText = "Please Select";
    $dropdown.appendChild($emptyValue);
  }
  Object.values(data).flat().forEach((item) => {
    let newOption = document.createElement("option");
    newOption.value = item.id;
    newOption.innerText = item.name || item.id;
    $dropdown.appendChild(newOption);
  });
  if (id) $dropdown.value = id;
}

document.addEventListener('DOMContentLoaded',function(){
 
  const params = new URLSearchParams(window.location.search);
  if(params.get('rq')){
    const parseData = params.get('rq').split('~')
    let presetYMM = {}
    for(let param of parseData){
      console.log(`param`,param);
      if(param.indexOf('mk_') !== -1)
        presetYMM.make = param;
      if(param.indexOf('md_') !== -1)
        presetYMM.model = param;
      if(param.indexOf('yr_') !== -1)
        presetYMM.year = param;
 
    }
    localStorage.setItem('YMM',JSON.stringify(presetYMM));
  }  
})
